export class UserSession {
  // check dom to determine if logged in. in future, might check a cookie instead so can cache the whole page
  // ie dom would contain no user-specific information on page load.
  isLoggedIn() {
    return document.querySelector("body .body")?.classList.contains("logged-in");
  }
}
